import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Nav2 from '../Nav2/Nav2';
import DonasiCard from '../DonasiCard/DonasiCard';
import './DonasiCard.css'




const DonasiCardMap = () => {
    const [donasi, setDonasi] = useState([])

    const fetchDonasiCardMap = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/openDonation'
        )
        console.log(data.data)
        setDonasi(data.data)
    }

    useEffect(() => {
        fetchDonasiCardMap()
    }, [])

    return (
        <div>
            <Nav2 />
            <h5 className="donasi-card-title">Semua Donasi Terbuka</h5>
            <div className="title-category">
                <div className="donasi-card-map">
                    {
                        donasi && donasi.map((c) => (
                            <DonasiCard
                                key={c.id}
                                name={c.donationName}
                                need={c.donationNeeded}
                                expired={c.expiredDate}
                                image={c.image}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default DonasiCardMap;
